export default __webpack_public_path__ + "static/media/pause.895d2f7f.mp3";